<script lang="ts">
	import NetPromptContent from './prompt.svx';
</script>

<div class="prose prose-blue dark:prose-invert max-w-none">
	<NetPromptContent />
</div>
